import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=09102247"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09102247')) {
      api.createRecord('09102247', component.options)
    } else {
      api.reload('09102247', component.options)
    }
    module.hot.accept("./staff.vue?vue&type=template&id=09102247", function () {
      api.rerender('09102247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/staff.vue"
export default component.exports